.types {
  display: flex;
  gap: var(--size-1);
}

.expanded {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  ul {
    flex-direction: column;
  }
}

button.toggle {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 1;
}

ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  font-size: var(--size-3);
  gap: var(--size-2);
  li {
    cursor: default;
    display: inline-flex;
    align-items: center;
    padding: var(--size-1);
    border-radius: var(--radius-sm);
    background-color: var(--pos-subtle-text-color);
    color: var(--pos-background-color);
    list-style: none;
  }
}
